import React from 'react';
import upcomingimg from '../assests/img/upcoming-img.jpg';


function Upcoming() {
  return (
    <>
      <section className="upcoming-event">

      <div className='sec-title'>
          <h2>UpComing Events</h2>
          <div class="separator"></div>
        </div>

        <div className="container">
          <div className="row">
            <div className='event-text col-md-6'>
             

            <div className="event-block">
                        	<div className="inner-box">
                            	<div className="title-box">
                                	<h3><a href="">8-9-10 Nov 2025</a></h3>
                                    <div class="event-date">JECC, Sitapura, Jaipur</div>
                                </div>
                                <div class="lower-box">
                                	<div class="text">Silver Show in Jaipur | 2025</div>
                                </div>
                                {/* <div class="event-date-box">
                                	<div class="date">JANUARY 14 , 2021</div>
                                    <div class="event-place">Sydney, Australia</div>
                                </div> */}
                            </div>
                        </div>


                        <div class="event-block">
                        	<div class="inner-box">
                            	{/* <div class="title-box">
                                	<h3>
                                    <a href="">31 Aug 1-2 Sept 2025</a>
                                    </h3>
                                    <div class="event-date">Agra, Utter Pradesh</div>
                                </div> */}
                                <div class="lower-box lower-box2">
                                	<div class="text">Silver Show in Agra | 2026</div>
                                </div>
                                {/* <div class="event-date-box">
                                	<div class="date">JANUARY 14 , 2021</div>
                                    <div class="event-place">Sydney, Australia</div>
                                </div> */}
                            </div>
                        </div>



            </div>
            <div className='event-image col-md-6'>
                <img src={upcomingimg}/>
              
            </div>
          </div>
        </div>
      </section> 
    </>
  )

}

export default Upcoming;
